import { NO_KEY } from '@/common/constants';
import { baseStoreCreator } from '@/utils/store';

export interface MetricsPayload {
  substantiationRate: string;
}

export const DEFAULT_VALUES: MetricsPayload = {
  substantiationRate: NO_KEY,
};

export const useStore = baseStoreCreator<MetricsPayload>(DEFAULT_VALUES);

export default useStore;
